import { ReactNode } from "react";
import styles from "../aic.module.css";
import { AitRowGroupButtons } from "./AitRowGroupButtons";
import { AitRowGroupTrafficLight } from "./AitRowGroupTrafficLight";
import { AitLocationBodyRow, AitTablePosition } from "./functions/interface";

interface AitRowFirstCellProps {
  location: AitLocationBodyRow;
}

/**
 * Render the first cell for a body row including group controls.
 *
 * @param props - Component props
 * @param props.location - The body row location
 */
export const AitRowFirstCell = ({ location }: AitRowFirstCellProps): ReactNode => (
  <td
    className={styles.aitCell}
    width="50px"
  >
    {location.row === 0 && (
      <AitRowGroupTrafficLight
        location={{
          position: AitTablePosition.bodyRowGroup,
          tableSection: location.tableSection,
          rowGroup: location.rowGroup,
          rowGroupId: location.rowGroupId,
        }}
      />
    )}
    {location.row === 0 && (
      <AitRowGroupButtons
        location={{
          position: AitTablePosition.bodyRowGroup,
          tableSection: location.tableSection,
          rowGroup: location.rowGroup,
          rowGroupId: location.rowGroupId,
        }}
      />
    )}
  </td>
);

AitRowFirstCell.displayName = "AitRowFirstCell";
